import { Layout } from "../components/Layout";
import { useHead } from "../lib/useHead";
import { AlertTriangle } from "lucide-react";

const ToComplete = ({ children }) => (
  <span className="rounded border border-dashed border-[hsl(var(--warn))]/60 bg-[hsl(var(--warn))]/5 px-1.5 py-0.5 text-[hsl(var(--warn))]">
    {children}
  </span>
);

export default function MentionsLegales() {
  useHead({ title: "Mentions légales — InfoSociété", description: "Mentions légales du service privé InfoSociété.", robots: "noindex,follow" });
  return (
    <Layout>
      <div className="mx-auto max-w-3xl px-5 py-10">
        <h1 className="font-display text-3xl font-semibold tracking-tight text-[hsl(var(--fg-primary))]">Mentions légales</h1>

        <div className="mt-4 flex items-start gap-2 rounded-lg border border-[hsl(var(--warn))]/40 bg-[hsl(var(--warn))]/5 p-4 text-sm text-[hsl(var(--fg-secondary))]">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[hsl(var(--warn))]" />
          <p>Les informations signalées en surbrillance restent <strong>à compléter</strong> par l'éditeur avant toute mise en ligne publique.</p>
        </div>

        <div className="mt-8 space-y-8 text-sm leading-relaxed text-[hsl(var(--fg-secondary))]">
          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Éditeur du site</h2>
            <p className="mt-2">
              Le site InfoSociété (infosociete.com) est un service privé et indépendant,
              édité par <ToComplete>[Raison sociale de l'éditeur]</ToComplete>,{" "}
              <ToComplete>[forme juridique et capital]</ToComplete>, immatriculée sous le{" "}
              <ToComplete>[SIREN / RCS de l'éditeur]</ToComplete>, dont le siège est situé{" "}
              <ToComplete>[adresse de l'éditeur]</ToComplete>.
            </p>
            <p className="mt-2">Contact : <ToComplete>[adresse e-mail de contact]</ToComplete>.</p>
            <p className="mt-2">Directeur de la publication : <ToComplete>[nom du responsable de publication]</ToComplete>.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Hébergement</h2>
            <p className="mt-2">Le site est hébergé par <ToComplete>[nom et adresse de l'hébergeur]</ToComplete>.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Indépendance et nature du service</h2>
            <p className="mt-2">
              InfoSociété est un service privé. Il n'est ni affilié, ni partenaire, ni mandaté
              par une administration ou un organisme public (INSEE, Infogreffe, INPI, etc.).
              Il ne délivre aucun document officiel.
            </p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Source des données</h2>
            <p className="mt-2">
              Les informations d'entreprises présentées sont issues de l'API publique
              « Recherche d'entreprises » mise à disposition par l'État français, adossée à
              la base SIRENE de l'INSEE et au Registre national des entreprises (RNE). La date
              de récupération est indiquée sur chaque fiche. Ces données sont diffusées sous
              les conditions de la diffusion publique ; les informations relatives aux personnes
              ayant exercé leur droit d'opposition à la diffusion ne sont pas affichées.
            </p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Exactitude des informations</h2>
            <p className="mt-2">
              InfoSociété restitue les données publiques sans les modifier ni en inventer.
              Une information absente de la source est signalée comme « Non disponible ». Le
              numéro de TVA intracommunautaire éventuellement affiché est calculé et n'est pas
              un numéro officiellement vérifié. InfoSociété ne saurait être tenu responsable
              d'une éventuelle inexactitude provenant de la source officielle.
            </p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Propriété intellectuelle</h2>
            <p className="mt-2">
              L'identité visuelle, les textes et la présentation du site InfoSociété sont
              protégés. Toute reproduction non autorisée est interdite.
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}
